import { useCallback } from 'react'

import { HStack, Spacer } from '@revolut-internal/ui-kit'

import { DropdownSelect } from 'modules/Monitoring/components/Filters/DropdownSelect'
import { TabBar } from 'modules/Monitoring/components/TabBar/TabBar'
import { TimeRangePagination } from 'modules/Monitoring/components/TimeRangePagination/TimeRangePagination'
import { TimeScale, VolumeComparisonType } from 'modules/Monitoring/types'

import { comparisonTypeOptions } from '../consts'
import { useTicketsVolumeDetails } from '../TicketsVolumeDetailsContext/TicketsVolumeDetailsContext'

import { CountBySelect } from './CountBySelect'

export const TicketsVolumeDetailsControlsBar = () => {
  const {
    currentTimeRange,
    timeScale,
    comparisonType,
    aggregationDimension,
    setCurrentTimeRange,
    setTimeScale,
    setComparisonType,
    setAggregationDimension,
    hasNextRange,
  } = useTicketsVolumeDetails()

  const handleTimeScaleChange = useCallback(
    (newTimeScale: TimeScale | null) => {
      if (!newTimeScale) {
        return
      }

      setTimeScale(newTimeScale)
    },
    [setTimeScale],
  )

  const handleComparisonTypeChange = useCallback(
    (newComparisonType: VolumeComparisonType | null) => {
      if (!newComparisonType) {
        return
      }

      setComparisonType(newComparisonType)
    },
    [setComparisonType],
  )

  return (
    <HStack align="center" space="s-16">
      <TabBar
        width={168}
        variant="segmented fit"
        behaviourVariant="action"
        tabs={[
          {
            value: TimeScale.Hourly,
            label: 'H',
          },
          {
            value: TimeScale.Daily,
            label: 'D',
          },
          {
            value: TimeScale.Weekly,
            label: 'W',
          },
        ]}
        value={timeScale}
        onChange={handleTimeScaleChange}
      />

      <DropdownSelect
        label="Compare with"
        value={comparisonType}
        options={comparisonTypeOptions}
        onChange={handleComparisonTypeChange}
      />

      <Spacer />

      <TimeRangePagination
        range={currentTimeRange}
        withTime={timeScale === TimeScale.Hourly}
        hasNext={hasNextRange}
        onRangeChange={setCurrentTimeRange}
      />

      <Spacer />

      <CountBySelect
        dimension={aggregationDimension}
        onChange={setAggregationDimension}
      />
    </HStack>
  )
}
